import { INVENTORY_MODULE } from "@/api_framework/api_config";
import { IGRNDetailResponse, IGRNDetailResponseData } from "@/api_framework/api_modals/Inventory";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useLoaderActions } from "@/app/hooks/useLoaderActions";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setPOGRNDetails } from "@/app_redux/reducers/slices/auth/inventory_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";

AxiosCurlirize(axios, () => {});
export const useGrnDetailAPI = () => {
  const configuration = useConfiguration();
  const dispatch = useAppDispatch();
  const { captureError } = useAPIUtils();
  const { sendCurl } = useCurlLogger();
  const { disable, enable } = useLoaderActions("isInventoryGrnDetailInProgress");

  const execute = useCallback(
    async (id: string, isTo: boolean = false) => {
      enable();
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);

        if (!id) {
          return;
        }

        const url = `${INVENTORY_MODULE?.GRN_DETAIL_API?.baseURL}${id}/${isTo ? "?request_for=transfer_order" : ""}`;

        const response: IGRNDetailResponseData = await axios
          .get(url, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IGRNDetailResponse>) => {
            disable();
            if (res.data.status) {
              dispatch(setPOGRNDetails(res.data.data));
              return res.data.data;
            } else {
              dispatch(setPOGRNDetails(null));
              return null;
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            return null;
          });
        return response;
      } catch (error) {
        disable();
        dispatch(setPOGRNDetails(null));
        // Handle errors
        if (axios.isAxiosError(error)) {
          captureError(error)
        } else {
          toast.error("Server Error: " + error.message);
        }
        return null;
      }
    },
    [dispatch, configuration],
  );

  return { execute };
};
